import { createTheme } from '@mui/material/styles';
let theme = createTheme();
theme = createTheme({
  palette: {
    error: { main: '#941418' },
    primary: { main: '#404E7C' },
  },
  components: {
    MuiPaper: {
      variants: [
        {
          props: { variant: 'screen' },
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '30vh',
            border: '1px none',
            boxShadow: '0px 4px 4px #00000040',
            background: '#FFFFEA',
            [theme.breakpoints.up('md')]: {
              minHeight: '60vh',
            },
            overflow: 'hidden',
          },
        },
      ],
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Cabin',
          fontWeight: 500,
        },
        shrink: {
          fontWeight: 700,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Cabin',
          fontWeight: 700,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: 'Cabin',
          fontWeight: 500,
          fontSize: '0.9rem',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          background: 'white',
          minWidth: '300px',
          [theme.breakpoints.up('md')]: {
            minWidth: '30vw',
          },
          [theme.breakpoints.up('lg')]: {
            minWidth: '20vw',
          },
          '&.subvariant-nobreakpoint': {
            minWidth: '0!important',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          background: 'white',
          minWidth: '300px',
          [theme.breakpoints.up('md')]: {
            minWidth: '30vw',
          },
          [theme.breakpoints.up('lg')]: {
            minWidth: '20vw',
          },
          '&.subvariant-nobreakpoint': {
            minWidth: '0!important',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: 'rgba(0, 0, 0, 0.6)',
        },
      },
    },
  },
  typography: {
    h1: {
      fontSize: '2rem',
      fontFamily: 'Montserrat',
      width: 'fit-content',
      marginBottom: '0px',
      WebkitTextStroke: '1px',
      WebkitTextStrokeColor: '#404E7C',
      letterSpacing: 0,
      fontWeight: 500,
      textAlign: 'center',
      [theme.breakpoints.up('sm')]: {
        fontSize: '3rem',
      },
    },
    title: {
      fontSize: '2rem',
      fontFamily: 'Montserrat',
      width: 'fit-content',
      marginBottom: '0px',
      WebkitTextStroke: '1px',
      WebkitTextStrokeColor: '#404E7C',
      letterSpacing: 0,
      fontWeight: 500,
      textAlign: 'center',
      [theme.breakpoints.up('sm')]: {
        fontSize: '3rem',
      },
    },
    subtitle1: {
      fontSize: '1rem',
      fontFamily: 'Montserrat',
      width: 'fit-content',
      marginBottom: '0px',
      WebkitTextStroke: '1px',
      WebkitTextStrokeColor: '#404E7C',
      letterSpacing: 0,
      fontWeight: 300,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.5rem',
      },
    },
    body2: {
      fontSize: '1rem',
      fontFamily: 'Montserrat',
      letterSpacing: 0,
      fontWeight: 400,
      alignItems: 'center',
      textAlign: 'center',
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.5rem',
      },
    },
    brandText: {
      fontFamily: 'Cabin',
      fontWeight: 600,
      [theme.breakpoints.up('sm')]: {
        fontSize: '2.5rem',
      },
    },
    brandText2: {
      fontFamily: 'Cabin',
      fontWeight: 600,
      [theme.breakpoints.up('xs')]: {
        fontSize: '1.2rem',
      },
    },
    caption: {
      fontFamily: 'Montserrat',
    },
    smallText: {
      fontSize: '0.5rem',
      width: 'fit-content',
      marginBottom: '0px',
      letterSpacing: 0,
      fontWeight: 300,
      [theme.breakpoints.up('sm')]: {
        fontSize: '0.7rem',
      },
    },
    formTitle: {
      fontFamily: 'Cabin',
      marginBottom: '0px',
      letterSpacing: 0,
      fontWeight: 700,
    },
  },
});
export default theme;
